import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Link from 'next/link';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import LeftMenu from '../components/buying/LeftMenu';
import ContactUs from '../components/ContactUs';
import Feature from '../components/buying/Feature';
import BuyForOfferMachine from '../components/BuyForOfferMachine';

const ProcessOfBuying = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('buying'),
      url: '/content/buying/before-bidding',
    },
    {
      label: 'Satın Alma Süreci',
      url: '/content/buying/process-of-buying',
    },
  ];

  const items = [
    {
      title: 'ONLINE AÇIK ARTTIRMA',
      description: 'İstediğiniz makinaya, istediğiniz teklifi tek tıkla kolayca verin. 7/24 online açık artırmaya katılın.',
      svgIcon: '/image/icons.svg#ic-auction2-yellow',
    },
    {
      title: 'EKSPERTİZ RAPORU',
      description: 'iyiMakina güvencesine sahip ekspertiz raporlarını ücretsiz inceleyin, aradığınız makinayı güvenle satın alın.',
      svgIcon: '/image/icons.svg#ic-checklist-yellow',
    },
    {
      title: 'GÜVENİLİR ÖDEME',
      description: 'Alıcı ve satıcı arasında güvenilir şekilde ödeme yapılmasını sağlayalım, zorluklarla uğraşmayın.',
      svgIcon: '/image/icons.svg#ic-wallet-yellow',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="process-of-buying" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Satın Alma Süreci</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  İkinci el iş makinası satın alabilmek için, iyiMakina.com’a üye olmanız gerekmektedir. Platformumuza üye olmak ücretsizdir.
                  Üyelik işlemlerinizi gerçekleştirip, teminat bedelini ödedikten sonra satışa sunulan makinaları inceleyebilir, satın almak istediğiniz makinanın açık artırmasına istediğiniz teklifi verebilirsiniz.
                </p>
                <p>
                  Satın almak istediğiniz makina için en iyi teklifi veren siz olursanız, ödeme işlemlerini tamamlayarak makinanın yeni sahibi olabilirsiniz.
                </p>
              </div>
            </div>
            <div className="row mb-30 align-items-stretch">
              {
                _.map(items, (item, index) => (
                  <Feature key={index} data={item} />
                ))
              }
            </div>
            <div className="row mb-20">
              <div className="col">
                <h2 className="h5">Güvenilir Ekspertiz</h2>
              </div>
              <div className="col-15">
                <p>
                  Ekspertiz raporları iki ana kısımdan oluşmaktadır. İlki; satılması planlanan makinanın genellikle Türkiye temsilcisi tarafından yapılan bağımsız ekspertiz incelemesi,
                  ikinci ise iyiMakina'nın uzman ekibi tarafından kayda alınan genel görünüm, hidrolik, şase kategorilerinde ortalama 100'ün üzerinde fotoğraf ve videoyu kapsayan çalışmadır.
                  Kapsamlı ekspertiz raporlarını, platformumuz üzerinden ücretsiz olarak inceleyebilirsiniz.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col">
                <h2 className="h5">Hızlı Teklif Kolaylığı</h2>
              </div>
              <div className="col-15">
                <p>
                  Bilgisayarınız, cep telefonunuz veya tabletiniz aracılığıyla açık artırmalara istediğiniz yerden, istediğiniz saatte tek tıkla katılabilirsiniz.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col">
                <h2 className="h5">Sorunsuz ve Güvenilir Ödeme</h2>
              </div>
              <div className="col-15">
                <p>
                  Alıcı ve satıcı arasındaki mali, hukuki ve operasyonel işleri biz halledelim. Sorunlar ortadan kalksın, güvenilir bir şekilde makinanızı satın alın.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15 col-lg mb-3 mb-lg-0">
                <div className="im-box im-box--white im-box--shadow im-box--height-100p">
                  <div className="im-step-bar3">
                    <div className="im-step-bar3__item">
                      <div className="im-step-bar3__item__indicator">
                        <div className="im-circle im-circle--outline-yellow">1</div>
                      </div>
                      <div className="im-step-bar3__item__title">Üye Ol</div>
                      <div className="im-step-bar3__item__description">
                        iyiMakina.com'a ücretsiz üye olun.
                      </div>
                    </div>
                    <div className="im-step-bar3__item">
                      <div className="im-step-bar3__item__indicator">
                        <div className="im-circle im-circle--outline-yellow">2</div>
                      </div>
                      <div className="im-step-bar3__item__title">Teminat Bedelini Öde</div>
                      <div className="im-step-bar3__item__description">
                        Teminat bedelini hemen öde, güvenilir yöntemlerle makina sahibi ol.
                      </div>
                    </div>
                    <div className="im-step-bar3__item">
                      <div className="im-step-bar3__item__indicator">
                        <div className="im-circle im-circle--outline-yellow">3</div>
                      </div>
                      <div className="im-step-bar3__item__title">Teklif Ver</div>
                      <div className="im-step-bar3__item__description">
                        Açık artırma süresinde en yüksek teklifi yapın, makinayı sorunsuz satın alın.
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-5">
                    <Link href="/register/membership-type">
                      <a className="im-button im-button--transparent">
                        <span className="fw-900 fs-16 text-gray4">SATIN ALMAK İÇİN ÜYE OL</span>
                      </a>
                    </Link>
                  </div>
                  <div className="text-center">
                    <Link href="/register/membership-type">
                      <a className="im-button im-button--primary">
                        <span>Hemen Üye Ol</span>
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-15 col-lg">
                <div className="im-box im-box--white im-box--shadow im-box--height-100p d-flex flex-column justify-content-center">
                  <div className="text-center mb-4">
                    <svg className="h-60 inline-block">
                      <use xlinkHref="/image/icons.svg#ic-tips-yellow" />
                    </svg>
                  </div>
                  <div className="text-center">
                    <span className="fw-900">AÇIK ARTIRMALARDAN NASIL HABERDAR OLURUM?</span>
                  </div>
                  <div className="im-step-bar3 mt-4">
                    <div className="im-step-bar3__item">
                      <div className="im-step-bar3__item__title">Üyelik</div>
                      <div className="im-step-bar3__item__description">
                        iyiMakina.com'a hemen
                        {' '}
                        <Link href="/register/membership-type">üye olun</Link>
                        , açık artırmadaki makinalara kolayca
                        {' '}
                        <Link href="/machinery">teklif verin</Link>
                        .
                      </div>
                    </div>
                    <div className="im-step-bar3__item">
                      <div className="im-step-bar3__item__title">İzleme Listesi</div>
                      <div className="im-step-bar3__item__description">
                        İlgilendiğiniz makinaları izleme listenize ekleyin, gelişmeleri size mail veya sms ile iletelim.
                      </div>
                    </div>
                    <div className="im-step-bar3__item">
                      <div className="im-step-bar3__item__title">E-Bülten Aboneliği</div>
                      <div className="im-step-bar3__item__description">
                        Ücretsiz iyiMakina e-bültenine
                        {' '}
                        <Link href="/">kayıt ol</Link>
                        , açık artırma tarihlerinden önce haberdar edelim.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <BuyForOfferMachine />
            <ContactUs about="Satın Alma Süreciyle" />
          </div>
        </div>
      </div>
    </main>
  );
};

ProcessOfBuying.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Satın Alma Süreci',
    },
  };
};

ProcessOfBuying.Layout = Layout;

export default withTranslation('common')(ProcessOfBuying);
